import { LOCALES_DEFAULT_AIRPORT } from '@packages/locale/constants/locales.ts'

export const useLocale = () => {
  const { market } = useRuntimeConfig().public
  const localeStore = useLocaleStore()

  const defaultAirport = LOCALES_DEFAULT_AIRPORT[market]
  const urls = localeStore.urls

  return {
    urls,
    defaultAirport,
  }
}